/**
 * design_handoff_accept_invitation §4 — screens 3/5 (Joined). Busy button,
 * auto-continues to the dashboard with the joined workspace active.
 *
 * @param {string} organizationName
 */
import React from "react";
import AuthStateCard from "../AuthPages/AuthStateCard";
import { Button } from "../../theme/untitled";

const JoinedScreen = ({ organizationName }) => (
  <AuthStateCard
    tone="success"
    icon="CheckCircle"
    title={`You've joined ${organizationName}`}
    actions={
      <Button loading disabled>
        Opening {organizationName}…
      </Button>
    }
  >
    <p>
      Opening the workspace dashboard. You can switch workspaces any time from
      the sidebar.
    </p>
  </AuthStateCard>
);

export default JoinedScreen;
